import * as React from "react";
import type { SVGProps } from "react";
const Diagonally_2LinesIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M4.707 17.435a1 1 0 1 0 1.414 1.414L18.85 6.121a1 1 0 1 0-1.414-1.414zm7.071 1.414a1 1 0 0 0 1.414 1.414l7.072-7.07a1 1 0 0 0-1.415-1.415z" clipRule="evenodd" /></svg>;
export default Diagonally_2LinesIcon;